// Maps a drug-class string (from Medication.drugClasses or the
// ingredient name) to a small color palette so the medications list
// can render visually-distinct pill icons. The palette uses the warm
// status tones from tokens.css so the meds list reads as a coherent
// brand surface, not a rainbow.

interface ClassPalette {
  bg: string;
  fg: string;
}

const PALETTES: Record<string, ClassPalette> = {
  cardiovascular: { bg: '#fee2e2', fg: '#991b1b' }, // soft red
  antihypertensive: { bg: '#fee2e2', fg: '#991b1b' },
  diabetes: { bg: '#cffafe', fg: '#0e7490' }, // cyan
  endocrine: { bg: '#cffafe', fg: '#0e7490' },
  mental: { bg: '#ddd6fe', fg: '#5b21b6' }, // purple
  psychiatric: { bg: '#ddd6fe', fg: '#5b21b6' },
  pain: { bg: '#ffd6b3', fg: '#7c2d12' }, // peach
  analgesic: { bg: '#ffd6b3', fg: '#7c2d12' },
  nsaid: { bg: '#ffd6b3', fg: '#7c2d12' },
  anticoagulant: { bg: '#fef3c7', fg: '#854d0e' }, // amber
  antiplatelet: { bg: '#fef3c7', fg: '#854d0e' },
  respiratory: { bg: '#cfe1ee', fg: '#0f4c75' }, // blue
  gi: { bg: '#fce7f3', fg: '#9d174d' }, // pink
  gastrointestinal: { bg: '#fce7f3', fg: '#9d174d' },
  antibiotic: { bg: '#a7d7c5', fg: '#14532d' }, // mint
  vitamin: { bg: '#a7d7c5', fg: '#14532d' },
  supplement: { bg: '#a7d7c5', fg: '#14532d' },
};

const FALLBACK: ClassPalette = { bg: '#e3edf5', fg: '#0f4c75' };

/** Pick a palette for a medication based on its class list or name. */
export function drugClassColor(classes: string[] | undefined | null, name?: string): ClassPalette {
  const candidates: string[] = [];
  if (Array.isArray(classes)) candidates.push(...classes.map((c) => c.toLowerCase()));
  if (name) candidates.push(name.toLowerCase());
  for (const c of candidates) {
    for (const key of Object.keys(PALETTES)) {
      if (c.includes(key)) {
        const palette = PALETTES[key];
        if (palette) return palette;
      }
    }
  }
  return FALLBACK;
}
